import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-google-sign-in-button',
  templateUrl: './google-sign-in-button.component.html',
  styleUrls: ['./google-sign-in-button.component.scss']
})
export class GoogleSignInButtonComponent {

  @Output() buttonClick = new EventEmitter();
  constructor() { }

  public onClick(event: Event) {
    this.buttonClick.emit(event);
  }

}
